import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row justify-content-center"
}
const _hoisted_2 = {
  key: 1,
  class: "row"
}
const _hoisted_3 = { class: "col-xl-8 offset-xl-2" }
const _hoisted_4 = {
  key: 0,
  class: "row"
}
const _hoisted_5 = { class: "col text-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col text-center" }, [
    /*#__PURE__*/_createElementVNode("h1", null, "Quiz")
  ])
], -1)
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col text-center" }
const _hoisted_9 = {
  key: 0,
  class: "text-primary"
}
const _hoisted_10 = {
  key: 0,
  class: "row"
}
const _hoisted_11 = { class: "col" }
const _hoisted_12 = {
  key: 1,
  class: "row mt-5"
}
const _hoisted_13 = {
  key: 0,
  class: "col"
}
const _hoisted_14 = {
  key: 1,
  class: "col"
}
const _hoisted_15 = { class: "row mt-5" }
const _hoisted_16 = { class: "col" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = { class: "col text-end" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = ["disabled"]
const _hoisted_21 = { key: 2 }
const _hoisted_22 = {
  key: 1,
  class: "row justify-content-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading_indicator = _resolveComponent("loading-indicator")!
  const _component_progress_bar = _resolveComponent("progress-bar")!
  const _component_multiple_choice_question = _resolveComponent("multiple-choice-question")!
  const _component_discussion_question = _resolveComponent("discussion-question")!
  const _component_quiz_results = _resolveComponent("quiz-results")!
  const _component_content_card = _resolveComponent("content-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_loading_indicator, { class: "col" })
        ]))
      : (_ctx.quiz)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_content_card, { "use-default-theme": true }, {
                default: _withCtx(() => [
                  (!_ctx.quiz)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                          _createVNode(_component_loading_indicator)
                        ])
                      ]))
                    : (!_ctx.isComplete && _ctx.quiz.questions)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _hoisted_6,
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, [
                              _createElementVNode("h3", null, [
                                _createTextVNode(_toDisplayString(_ctx.quiz.name) + " - ", 1),
                                (_ctx.quiz.questions)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.quiz.questions.length) + " Questions ", 1))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]),
                          (_ctx.currentQuestionIndex >= 0 && _ctx.quiz.questions)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                _createElementVNode("div", _hoisted_11, [
                                  _createVNode(_component_progress_bar, {
                                    value: _ctx.currentQuestionIndex,
                                    total: _ctx.quiz.questions.length,
                                    variant: 'secondary'
                                  }, null, 8, ["value", "total"])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.currentQuestion)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                (_ctx.currentQuestion.isMultipleChoice)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                      _createVNode(_component_multiple_choice_question, {
                                        modelValue: _ctx.currentQuestion,
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentQuestion) = $event))
                                      }, null, 8, ["modelValue"])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.currentQuestion.isDiscussion)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                      _createVNode(_component_discussion_question, {
                                        modelValue: _ctx.currentQuestion,
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currentQuestion) = $event))
                                      }, null, 8, ["modelValue"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("div", _hoisted_16, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-gray btn-gray-outline",
                                disabled: !_ctx.canClickBack(),
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.currentQuestionIndex--))
                              }, " Back ", 8, _hoisted_17)
                            ]),
                            _createElementVNode("div", _hoisted_18, [
                              (
                                        _ctx.currentQuestionIndex <
                                        _ctx.quiz.questions.length - 1
                                    )
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    type: "button",
                                    class: "btn btn-primary",
                                    disabled: !_ctx.canClickNext(),
                                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.currentQuestionIndex++))
                                  }, " Next ", 8, _hoisted_19))
                                : (
                                        _ctx.currentQuestionIndex ==
                                        _ctx.quiz.questions.length - 1
                                    )
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 1,
                                      type: "button",
                                      class: "btn btn-primary",
                                      disabled: !_ctx.canClickSubmit(),
                                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.submit()))
                                    }, " Submit ", 8, _hoisted_20))
                                  : _createCommentVNode("", true)
                            ])
                          ])
                        ], 64))
                      : _createCommentVNode("", true),
                  (_ctx.isComplete)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        (_ctx.quizResults)
                          ? (_openBlock(), _createBlock(_component_quiz_results, {
                              key: 0,
                              quiz: _ctx.quizResults,
                              onTryAgain: _cache[5] || (_cache[5] = ($event: any) => (_ctx.tryAgainClicked()))
                            }, null, 8, ["quiz"]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                              _createVNode(_component_loading_indicator, { class: "col" })
                            ]))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true)
  ]))
}